import { action } from 'typesafe-actions';

import { ConfigActionTypes } from './types';

export const getConfigRecord = (university: string) => action(ConfigActionTypes.GET_UNI_CONFIG, { university });
export const getConfigRecordSuccess = (config: any) => action(ConfigActionTypes.GET_UNI_CONFIG_SUCCESS, config);
export const getConfigRecordFailure = (error: string) => action(ConfigActionTypes.GET_UNI_CONFIG_FAILURE, error);

export const getNavigationUrls = (university: string) => action(ConfigActionTypes.GET_NAVIGATION_URLS, { university });
export const getNavigationUrlsSuccess = (urls: { apply?: string; casStudent?: string; casStaff?: string }) => 
  action(ConfigActionTypes.GET_NAVIGATION_URLS_SUCCESS, urls);
export const getNavigationUrlsFailure = (error: string) => action(ConfigActionTypes.GET_NAVIGATION_URLS_FAILURE, error);
